import type { AxiosResponseHeaders } from 'axios';

import { createAxiosInstance } from '@/package';

import { axiosActionHistory } from '../actionHistory/axiosActionHistory';
import { ApiError, ERROR_CODE, ERROR_CODE_NAME_MAPPER } from './error';

export const responseErrorHandler = (
  error: ApiError<any, AxiosResponseHeaders>,
) => {
  /* v8 ignore start */
  const resultCode = (error.data.resultCode ??
    ERROR_CODE[9999]) as keyof typeof ERROR_CODE_NAME_MAPPER;
  const errorClassName = ERROR_CODE_NAME_MAPPER[resultCode];
  const { data, headers, status, statusText } = error ?? {};
  /* v8 ignore end */

  throw new ApiError({
    data: data as any,
    headers: headers as AxiosResponseHeaders,
    message: data.resultMsg ?? error.message,
    name: `[${resultCode}] ${errorClassName}`,
    status,
    statusText,
    config: error.config,
  });
};

const instance = createAxiosInstance({
  responseErrorHandler,
});

// axios action history interceptor 등록
instance.interceptors.request.use(config =>
  axiosActionHistory.onRequest(config),
);
instance.interceptors.response.use(
  response => axiosActionHistory.onResponse(response),
  error => axiosActionHistory.onResponseError(error),
);

export default instance;
